import {IconProps, TrashIcon, WorkingCopyOwnIcon, WorkingCopyEdited} from '@genestack/ui';
import React from 'react';

import {EyeIcon} from '../../../../../components/icons/eye-icon';

import styles from './tooltip-icons.module.css';
import {TooltipOptions, wrapWithTooltip} from '../../../../../components/tooltip/wrap-with-tooltip';

const tooltipOptions: TooltipOptions = {
    portalContainer: document.body
};

export const OwnWorkingCopyTooltipIcon = (props: IconProps) =>
    wrapWithTooltip(
        <span className={styles.iconWrapper}>
            <WorkingCopyOwnIcon data-qa="own-working-copy-icon" {...props} />
        </span>,
        'My draft',
        tooltipOptions
    );

export const WorkingCopyTooltipIcon = (props: IconProps) =>
    wrapWithTooltip(
        <span className={styles.iconWrapper}>
            <WorkingCopyEdited data-qa="working-copy-icon" {...props} />
        </span>,
        'Someone is editing',
        tooltipOptions
    );

export const ReadOnlyTooltipIcon = (props: IconProps) =>
    wrapWithTooltip(
        <span className={styles.iconWrapper}>
            <EyeIcon data-qa="read-only-icon" {...props} />
        </span>,
        'Read-only',
        tooltipOptions
    );

export const DeletedTooltipIcon = (props: IconProps) =>
    wrapWithTooltip(
        <span className={styles.iconWrapper}>
            <TrashIcon data-qa="bin-icon" {...props} />
        </span>,
        'Deleted',
        tooltipOptions
    );
